import React from "react";
import Navbar from  "../Navbar/Navbar";
import LandingPage from "./LandingPage/LandingPage";
const Home = () => {
  
return(
    <>
<Navbar />
<LandingPage />
</>
  );
};

export default Home;
